<template>
    <app-label class="mt-2">The tyre:</app-label>

    <input-select
        class="mt-4"
        placeholder="Tyre Brand"
        :options="brands"
        labelKey="name"
        :modelValue="brand"
        @update:modelValue="$emit('update:brand', $event)"
        :error="errors.brand_id"
        :readonly="!allowProductEdit"
    ></input-select>

    <input-select
        class="mt-4"
        placeholder="Tyre Range"
        :options="products"
        labelKey="name"
        :modelValue="product"
        @update:modelValue="$emit('update:product', $event)"
        :error="errors.product_id"
        :readonly="!allowProductEdit"
    ></input-select>

    <input-error v-if="errors.product_id">Please select a tyre to review</input-error>

    <app-label class="mt-4">The size:</app-label>

    <div class="flex items-center mt-4">
        <div class="flex-grow flex-shrink mr-4 basis-1/3">
            <input-basic
                placeholder="Width"
                :modelValue="width"
                type="number"
                @update:modelValue="$emit('update:width', $event)"
                :error="errors['tyre_details.width']"
            ></input-basic>
        </div>
        <div class="flex-grow basis-20">
            <input-basic
                placeholder="Profile"
                :modelValue="profile"
                type="number"
                @update:modelValue="$emit('update:profile', $event)"
                :error="errors['tyre_details.profile']"
            ></input-basic>
        </div>
        <div class="flex-grow-0 mx-4 text-center">
            <span class="">Rim</span>
        </div>
        <div class="flex-grow basis-20">
            <input-basic
                placeholder="Rim"
                :modelValue="rim"
                type="number"
                @update:modelValue="$emit('update:rim', $event)"
                :error="errors['tyre_details.rim']"
            ></input-basic>
        </div>
    </div>

    <input-basic
        class="mt-4"
        placeholder="Miles"
        :modelValue="miles"
        type="number"
        @update:modelValue="$emit('update:miles', $event)"
        :error="errors['tyre_details.miles']"
    ></input-basic>

    <input-select
        class="mt-4"
        placeholder="Tyre age"
        :options="tyreAges"
        :modelValue="tyreAge"
        @update:modelValue="$emit('update:tyreAge', $event)"
        :error="errors['tyre_details.tyre_age']"
    ></input-select>

    <input-error v-if="hasTyreSizeErrors">Please fill in details about the tyre</input-error>
</template>
<script>
import InputError from "@/Components/Forms/Inputs/InputError.vue";
import InputBasic from "@/Components/Forms/Inputs/InputBasic.vue";
import InputSelect from "@/Components/Forms/Inputs/InputSelect.vue";
import AppLabel from "@/Components/Forms/AppLabel.vue";
import { usePage } from '@inertiajs/inertia-vue3';

export default {
    components: {
        InputError,
        InputBasic,
        InputSelect,
        AppLabel,
    },
    props: {
        product: [Number, String, Object],
        brand: [Number, String, Object],
        width: [Number, String],
        profile: [Number, String],
        rim: [Number, String],
        miles: [Number, String],
        drivingStyle: String,
        roadType: String,
        tyreAge: String,
        errors: Object,
        allowProductEdit: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            brands: [],
            products: [],
        }
    },
    computed: {
        tyreAges() {
            return usePage().props.value.config.reviews.tyre_ages;
        },
        hasTyreSizeErrors() {
            const properties = ['width', 'profile', 'rim', 'miles', 'tyre_age'];

            for (let property of properties) {
                if (this.errors.hasOwnProperty('tyre_details.' + property)) return true;
            }

            return false;
        }
    },
    watch: {
        async brand() {
            await this.getProducts();

            if (this.products && this.products[0]) {
                this.$emit('update:product', this.products[0]);
            } else {
                this.$emit('update:product', null);
            }
        },
    },
    mounted() {
        if (this.allowProductEdit) {
            this.getBrands();

            if (this.brand) {
                this.getProducts();
            }
        }
    },
    methods: {
        async getBrands() {
            const response = await axios.get(this.route("api.brands.index"));
            this.brands = response.data;
        },
        async getProducts() {
            if (!this.brand) {
                this.products = [];

                return;
            }

            const response = await axios.get(this.route("api.brands.products.index", this.brand));
            this.products = response.data;
        },
    }
};
</script>

<style lang="scss" scoped></style>
